
<script>
export default {
 mounted() {
      this.$router.back()
    }
}
</script>


// WEBPACK FOOTER //
// src/views/friendLink/workNews.vue